import React, { useState } from "react";

import { FaqCategory as FaqCategoryData } from "../../../../content/faq";

import style from "./styles.module.scss";

interface FaqCategoryProps {
  category: FaqCategoryData;
}

export default function FaqCategory({ category }: FaqCategoryProps) {
  const { name, questions, slug } = category;
  const [open, setOpen] = useState(false);
  const [openQuestions, setOpenQuestions] = useState<string[]>([]);

  const toggleQuestion = (id: string) =>
    setOpenQuestions((current) =>
      current.includes(id)
        ? current.filter((openId) => openId !== id)
        : [...current, id],
    );

  return (
    <li className={style.category}>
      <button
        aria-controls={`${slug}-content`}
        aria-expanded={open}
        className={style.trigger}
        id={`${slug}-trigger`}
        onClick={() => setOpen(!open)}
        type="button"
      >
        <span className={`pgm-title-large ${style.name}`}>{name}</span>
        <span aria-hidden="true" className={`material-symbols-sharp ${style.chevron}`}>
          {open ? "keyboard_arrow_up" : "keyboard_arrow_down"}
        </span>
      </button>

      {open && (
        <ul
          aria-labelledby={`${slug}-trigger`}
          className={style.questions}
          id={`${slug}-content`}
        >
          {questions.map(({ answer, question, slug: questionSlug }) => {
            const questionOpen = openQuestions.includes(questionSlug);

            return (
              <li className={style.question} key={questionSlug}>
                <button
                  aria-controls={`${questionSlug}-content`}
                  aria-expanded={questionOpen}
                  className={style.questionTrigger}
                  id={`${questionSlug}-trigger`}
                  onClick={() => toggleQuestion(questionSlug)}
                  type="button"
                >
                  <span className={`pgm-title-medium ${style.questionText}`}>
                    {question}
                  </span>
                  <span
                    aria-hidden="true"
                    className={`material-symbols-sharp ${style.chevron}`}
                  >
                    {questionOpen ? "remove" : "add"}
                  </span>
                </button>

                {questionOpen && (
                  <div
                    aria-labelledby={`${questionSlug}-trigger`}
                    className={`pgm-body-large ${style.answer}`}
                    id={`${questionSlug}-content`}
                  >
                    {answer}
                  </div>
                )}
              </li>
            );
          })}
        </ul>
      )}
    </li>
  );
}
